import { ConfigType } from './type';

export const CONFIG: ConfigType = {
  // ENV
  environment: 'production',
  VITE_CURRENT_ENV: {
    isLocal: false,
    isDev: false,
    isStaging: false,
    isMock: false,
    isProd: true,
    isWeb: true,
    isMobile: false,
  },
  VITE_APP_DOMAINS: {
    POINTPAY: 'https://payments.pointcraft.io',
    POS: 'https://dashboard.point-craft.com',
    POINTPAY_PUBLIC: 'https://v.pointcraft.io',
    MANAGEMENT: 'https://app.pointcraft.io',
  },

  // API
  // VITE_HOST_API: 'https://api-v4.pncf.app',
  // VITE_PUBLIC_API: 'https://api-v4.pncf.app',
  // VITE_ATH_API: 'https://pointcraft-functions-public-prod-605668549639.us-central1.run.app/api',

  VITE_HOST_API: 'https://api-v4.pncf.app/b',
  VITE_PUBLIC_API: 'https://api-v4.pncf.app/b',
  VITE_ATH_API: 'https://api-v4.pncf.app/f/api',
  VITE_ATH_API_PUBLIC: 'https://api-v4.pncf.app/f/api',
  // # FIREBASE
  VITE_FIREBASE_API_KEY: 'AIzaSyDTwtSwfuOnOlyqUKazKPQdlpcpET8b1MU',
  VITE_FIREBASE_AUTH_DOMAIN: 'pointcraft-inc-prod.firebaseapp.com',
  VITE_FIREBASE_PROJECT_ID: 'pointcraft-inc-prod',
  VITE_FIREBASE_STORAGE_BUCKET: 'pointcraft-inc-prod.firebasestorage.app',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '605668549639',
  VITE_FIREBASE_APPID: '1:605668549639:web:282889fee734f3287136a2',
  VITE_FIREBASE_MEASUREMENT_ID: 'G-0LYL3NQPEX',
  VITE_FIREBASE_REALTIME_DB_URL: 'https://pointcraft-inc-prod-default-rtdb.firebaseio.com/',
  VITE_STRIPE_PUBLISHABLE_KEY: 'pk_live_Mdaodl3NEfZ0hRXA0Gwdsr0Y',
  VITE_TILLED_PUBLISHABLE_KEY:
    'pk_ybONTaBIgyNFotuOCBedpPIxFyNf1uqeEH4ZOl5m1fQN5cyqUVZhNd4RaWjjYy9lWuQIJBJ0KyRSW9f0OcRWCV5YTuuUQpPCGHx5',
  // MSC
  VITE_ASSETS_API: 'none',
  VITE_MAIN_TEST_ACCOUNT_NUMBER: '',
  VITE_APP_VERSION: '8.1.8',
  VITE_CUSTOMER_SERVICE_PHONE: '(612) 473-5556',
  VITE_CUSTOMER_SERVICE_EMAIL: 'support@point-craft.com',
  VITE_DEFAULT_TERMINAL_READER_LOCATION_ID: 'tml_Ft9REwhxixOEwS',
  VITE_SITE_ID: 'point_of_sale', // Default to POS, can be overridden by env var
  VITE_SENTRY_DSN:
    'https://be107b84a8eb90636ac04044335b334a@o4507762364448768.ingest.us.sentry.io/4510622208229376',
  VITE_SENTRY_ORG: 'pointcraft-inc',
  VITE_SENTRY_PROJECT: 'pointcraft-frontend',
  VITE_MANAGER_SENTRY_DSN:
    'https://82a03e3ec2ebd1f8d94d1ce8ecaa7fee@o4507762364448768.ingest.us.sentry.io/4512036329357312',
  VITE_MANAGER_SENTRY_ORG: 'pointcraft-inc',
  VITE_MANAGER_SENTRY_PROJECT: 'pointcraft-manager',
  VITE_GOOGLE_MAPS_API_KEY: 'AIzaSyBpg6pBHyGHU0mZLse3QvJ25Mr8OyhX5e4',
  VITE_RECAPTCHA_SITE_KEY: '6Ld5KoMsAAAAANY-9ZhXH4bbGoyStr4gCUNJ52fp',
  VITE_RECAPTCHA_ENABLED: true,
  VITE_USE_FIREBASE_EMULATORS: false,
  VITE_JOTFORM_RECAPTCHA_SITE_KEY: '6LcAIoEsAAAAALW2kMFiwXqWDTDK6Musi2cu2bTM',
};
